const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ShopTheLook extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this._stuck = false
    this.setupObservers()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 2.6,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.md}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  setupObservers () {
    this.onTopEntry = this.onTopEntry.bind(this)
    this.onBottomEntry = this.onBottomEntry.bind(this)

    const config = {
      threshold: 0,
    }

    this.topObserver = new IntersectionObserver(this.onTopEntry, config)
    this.bottomObserver = new IntersectionObserver(this.onBottomEntry, config)

    this.topObserver.observe(this.els.top.element)
    this.bottomObserver.observe(this.els.bottom.element)
  }

  onTopEntry ([entry]) {
    const elPosition = entry.boundingClientRect
    const elTop = elPosition.top

    if (!entry.isIntersecting && elTop < 0) {
      this.stuck = true
      return
    }

    if (entry.isIntersecting && elTop > 0) {
      this.stuck = false
    }
  }

  onBottomEntry ([entry]) {
    if (entry.isIntersecting) {
      this.stuck = false
      return
    }

    if (!entry.isIntersecting) {
      this.stuck = true
    }
  }

  get stuck () {
    return this._stuck
  }

  set stuck (value) {
    this._stuck = value
    this.externalEls.container?.element.classList.toggle(
      'sec-ShopTheLook-stuck',
      value,
    )
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook)
}
